import { useMemo } from 'react';

import { getEpisodeOtt } from '../utils/get-episode-ott';

import { useReadEpisodePlayerBaseInfo } from './use-read-episode-player-base-info';

export function useEpisodeOtt(contentId: string) {
    const episode = useReadEpisodePlayerBaseInfo(contentId);

    return useMemo(() => (episode ? getEpisodeOtt(episode) : undefined), [episode]);
}
